import { createContext, useContext } from 'react';

// Create context
const SnackbarContext = createContext(undefined);

// Export the context
export default SnackbarContext;

// Custom hook to use the snackbar context
export const useSnackbar = () => {
  const context = useContext(SnackbarContext);
  if (context === undefined) {
    throw new Error('useSnackbar must be used within a SnackbarProvider');
  }
  return context;
};